export const beneficiarios = [
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/EquiPecuarioLeche.pdf",
			},
			

		],			
			nombre:"Entrega de Equipamiento Pecuario Bovino Productor de Leche",
			anio:"2025"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/EquiPecuario.pdf",
			},
			

		],			
			nombre:"Entrega de Equipamiento Pecuario Bovino Productor de Carne",
			anio:"2025"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/Cunicultura.pdf",
			},
			

		],			
			nombre:"Entrega de Conejos",
			anio:"2025"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/SementalOvino.pdf",
			},
			

		],			
			nombre:"Entrega de Semental Ovino",
			anio:"2025"
	},
	{
		urls: [
		
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/Mecanizacion.pdf",
			},
			

		],			
			nombre:"Entrega de Equipamiento Agrícola Mecanización",
			anio:"2025"
	},
	{
		urls: [
		
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/Herramientas.pdf",
			},
			

		],			
			nombre:"Entrega de Equipamiento Agrícola Herramientas",
			anio:"2025"
	},
		{
		urls: [
		
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/VientresPorcinos.pdf",
			},
			

		],			
			nombre:"Entrega de Vientres Porcinos",
			anio:"2025"
	},
		{
		urls: [
		
			{
			  id: "1",
			  nombrelink: "1° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/3T/Aves3T.pdf",
			},
			{
			  id: "2",
			  nombrelink: "2° Entrega (Cuarto Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/Aves.pdf",
			},
			

		],			
			nombre:"Entrega de Aves",
			anio:"2025"
	},
	{
		urls: [
		
			{
			  id: "1",
			  nombrelink: "1° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/3T/Huertos3T.pdf ",
			},
			{
			  id: "2",
			  nombrelink: "2° Entrega (Cuarto Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/Huertos.pdf ",
			},
			

		],			
			nombre:"Entrega de Huertos Familiares",
			anio:"2025"
	},
	{
		urls: [
		
			{
			  id: "1",
			  nombrelink: "1° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/3T/VientresOvino3T.pdf",
			},
			{
			  id: "2",
			  nombrelink: "2° Entrega (Cuarto Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/VientresOvinos.pdf",
			},
			

		],			
			nombre:"Entrega de Vientres Ovinos",
			anio:"2025"
	},
		{
		urls: [
		
			{
			  id: "1",
			  nombrelink: "1° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/3T/MejoramientoG3T.pdf",
			},
			

		],			
			nombre:"Entrega de Mejoramiento Genético",
			anio:"2025"
	},
	{
		urls: [
		
			{
			  id: "1",
			  nombrelink: "1° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/3T/Jitomate3T.pdf ",
			},
			{
			  id: "2",
			  nombrelink: "2° Entrega (Cuarto Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/Jitomate.pdf ",
			},
			

		],			
			nombre:"Entrega de Jitomate",
			anio:"2025"
	},

	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/2T/EquiAves2T.pdf",
			},
			{
			  id: "2",
			  nombrelink: "2° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/3T/EquipAves3T.pdf",
			},
			{
			  id: "3",
			  nombrelink: "3° Entrega (Cuarto Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/EquipaAves.pdf",
			},
			

		],			
			nombre:"Entrega de Equipamiento aves",
			anio:"2025"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/2T/HijuelosMaguey2T.pdf",
			},
			{
			  id: "2",
			  nombrelink: "2° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/3T/Hijuelos3T.pdf ",
			},
			{
			  id: "3",
			  nombrelink: "3° Entrega (Cuarto Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/HijuelosMaguey.pdf ",
			},
			

		],			
			nombre:"Entrega de Hijuelos de Maguey",
			anio:"2025"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/2T/Cebada2T.pdf",
			},
			{
			  id: "2",
			  nombrelink: "2° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/3T/Cebada3T.pdf ",
			},
			{
			  id: "3",
			  nombrelink: "2° Entrega (Cuarto Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/Cebada.pdf ",
			},
			

		],			
			nombre:"Entrega de Semilla Cebada",
			anio:"2025"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/2T/Avena2T.pdf",
			},
			{
			  id: "2",
			  nombrelink: "2° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/3T/Avena3T.pdf ",
			},
			{
			  id: "3",
			  nombrelink: "3° Entrega (Cuarto Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/Avena.pdf ",
			},

		],			
			nombre:"Entrega de Semilla Avena",
			anio:"2025"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/2T/Maiz2T.pdf",
			},
			{
			  id: "2",
			  nombrelink: "2° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/3T/Maiz3T.pdf",
			},
			{
			  id: "3",
			  nombrelink: "3° Entrega (Cuarto Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Beneficiarios/4T/Maiz.pdf",
			},
			

		],			
			nombre:"Entrega de Semilla Maíz",
			anio:"2025"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/AvesAmpliacion4T.pdf",
			},
			

		],			
			nombre:"Entrega de Aves (Ampliación)",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/EquipamientoPecuarioOvino4T.pdf",
			},
			

		],			
			nombre:"Entrega Equipamiento Pecuario Ovino (Semental)",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/EqAgricolaMochila4T.pdf",
			},
			

		],			
			nombre:"Entrega Equipamiento Agrícola (Mochila Fertilizante)",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/EquipamientoBovinoLeche.pdf",
				//Modificar link
			},
			

		],			
			nombre:"Entrega Equipamiento Pecuario Bovino (Ordeñadora-Becerreras)",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/EquipamientoBovino.pdf",
			},
			

		],			
			nombre:"Entrega Equipamiento Pecuario Bovino (Molino-Rollos)",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/EquipamientoAgricolaMaguey4T.pdf",
			},
			

		],			
			nombre:"Entrega Equipamiento Agrícola (Herramientas)",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Acuicola4T.pdf",
			},
			

		],			
			nombre:"Entrega Acuícola",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Apicultura4T.pdf",
			},
			

		],			
			nombre:"Entrega Apicultura",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/GeneticoOvino4T.pdf",
			},
			

		],			
			nombre:"Entrega Mejoramiento Genético Ovino",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/GeneticoBovino4T.pdf",
			},
			

		],			
			nombre:"Entrega Mejoramiento Genético Bovino",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Cafe4T.pdf",
			},
			

		],			
			nombre:"Entrega  de Planta de Café",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Manzana4T.pdf",
			},
			

		],			
			nombre:"Entrega  de Planta de Manzana",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Limon4T.pdf",
			},
			

		],			
			nombre:"Entrega  de Planta de Limón",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Nogal4T.pdf",
			},
			

		],			
			nombre:"Entrega  de Planta de Nogal",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Aguacate4T.pdf",
			},
			

		],			
			nombre:"Entrega  de Planta de Aguacate",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Cuarto Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/AnalisisSuelos4T.pdf",
			},
			

		],			
			nombre:"Entrega  de Análisis de Suelos",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Tercer Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/3T/Aves3T.pdf",
			},
			{
				id: "2",
				nombrelink: "2° Entrega (Cuarto Trimestre)",
				enlace:
				  "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Aves4T.pdf",
			  },

		],			
			nombre:"Entrega de Aves",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Tercer Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/3T/Huertos3T.pdf",
			},
			{
				id: "2",
				nombrelink: "2° Entrega (Cuarto Trimestre)",
				enlace:
				  "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Huertos4T.pdf",
			  },

		],			
			nombre:"Entrega de Huertos Familiares",
			anio:"2024"
	},

	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Tercer Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/3T/EqOvino3T.pdf",
			},
			{
				id: "2",
				nombrelink: "2° Entrega (Cuarto Trimestre)",
				enlace:
				  "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/EquipamientoOvino4T.pdf",
			  },

		],			
			nombre:"Entrega de Equipamiento Ovino",
			anio:"2024"
	},
	
	
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/2T/HijuelosMaguey2T.pdf",
			},
			{
				id: "2",
				nombrelink: "2° Entrega (Tercer Trimestre)",
				enlace:
				  "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/3T/HijuelosMaguey3T.pdf",
			  },
			  {
				id: "3",
				nombrelink: "3° Entrega (Cuarto Trimestre)",
				enlace:
				  "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Hijuelos4T.pdf",
			  },

		],			
			nombre:"Entrega de Hijuelos de Maguey",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Tercer Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/3T/Jitomate3T.pdf",
			},
			{
				id: "2",
				nombrelink: "2° Entrega (Cuarto Trimestre)",
				enlace:
				  "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Jitomate4T.pdf",
			  },

		],			
			nombre:"Entrega de Semilla de Jitomate",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Tercer Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/3T/Maiz3T.pdf",
			},
			{
				id: "2",
				nombrelink: "2° Entrega (Cuarto Trimestre)",
				enlace:
				  "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Maiz4T.pdf",
			  },

		],			
			nombre:"Entrega de Semilla Maíz",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/2T/Avena2T.pdf",
			},
			{
				id: "2",
				nombrelink: "2° Entrega (Tercer Trimestre)",
				enlace:
				  "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/3T/Avena3T.pdf",
			  },

		],			
			nombre:"Entrega de Semilla de Avena",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/2T/Cebada2T.pdf",
			},
			{
				id: "2",
				nombrelink: "2° Entrega (Tercer Trimestre)",
				enlace:
				  "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/3T/Cebada3T.pdf",
			  },
			  {
				id: "3",
				nombrelink: "3° Entrega (Cuarto Trimestre)",
				enlace:
				  "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/4T/Cebada4T.pdf",
			  },

		],			
			nombre:"Entrega de Semilla de Cebada",
			anio:"2024"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Primer Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/MujerRural.pdf",
			},
			{
				id: "2",
				nombrelink: "2° Entrega (Segundo Trimestre)",
				enlace:
				  "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/2T/MujerValor2.pdf",
			  },
			  {
				id: "3",
				nombrelink: "3° Entrega (Tercer Trimestre)",
				enlace:
				  "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Beneficiarios/3T/MujerValor3T.pdf",
			  },
		],			
			nombre:"Agregación de Valor para Mujer Rural",
			anio:"2024"
	},
	
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/Acuacultura/CriasBagre2023.pdf",
			},],
		nombre:"Cría de Bagre",
		anio:"2023"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/Acuacultura/TruchaArcoiris2023.pdf",			
			},],
		nombre:"Trucha Arcoíris",
		anio:"2023"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Entrega 3er Trimestre",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/3T/BeneficiariosNogal.pdf",
			},],		
		nombre:"Nogal",
		anio:"2023"
	},

	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Entrega 3er Trimestre",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/3T/BeneficiariosLichi.pdf",
			},],		
		nombre:"Lichi",
		anio:"2023"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Entrega 3er Trimestre",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/3T/BeneficiariosCafe.pdf",
			},],
		nombre:"Café",
		anio:"2023"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Entrega 3er Trimestre",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/3T/BeneficiariosManzana.pdf",
			},],			
		nombre:"Manzana",
		anio:"2023"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Entrega 3er Trimestre",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/3T/BeneficiariosLimon.pdf",
			},],
		nombre:"Limón",
		anio:"2023"
	},
		{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/2T/Aguacate.pdf",
			},
			{
				 id: "2",
			  nombrelink: "2° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/BeneficiariosAguacate.pdf",
			}
			,],			
		nombre:"Aguacate",
		anio:"2023"
	},
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/Aves_Postura_2023.pdf",
	// 		},],			
	// 	nombre:"Aves Postura",
	//     anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/AnalisisSuelos_2023.pdf",
	// 		},],			
	// 	nombre:"Anális de Suelos",
	// 	anio:"2023"
	// },
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/2T/Cebada.pdf",
			},
			{
				id: "2",
			  nombrelink: "2° Entrega (Tercer Trimestre)",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/BeneficiariosCebada.pdf",
			},],			
		nombre:"Cebada",
		anio:"2023"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/2T/Avena.pdf",
			},
			{
				id: "2",
			  nombrelink: "2° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/BeneficiariosAvena.pdf",
			}
			,],			
		nombre:"Avena",
		anio:"2023"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/2T/Maiz.pdf",
			},
			{
			   id: "2",
			  nombrelink: "2° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/BeneficiariosMaiz.pdf",
			},],			
		nombre:"Maiz",
		anio:"2023"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/2T/Jitomate.pdf",
			},
			{
				id: "2",
			  nombrelink: "2° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/BeneficiariosJitomate.pdf",
			},],			
		nombre:"Jitomate",
		anio:"2023"
	},

	// {
	// 	urls: [
	// 		{
			 
	// 		 id: "1",
	// 		  nombrelink: " Entrega ",
	// 		  enlace:
	// 			"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/BeneficiariosGeneticoBovino.pdf",
	// 		},

	// 	],					
	// 	nombre:"Mejoramiento Genético Bonivo Leche",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/3T/BeneficiariosBovinoCarne.pdf",
	// 		},],			
	// 	nombre:"Mejoramiento Genético Bonivo Carne",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/3T/BeneficiariosOvino.pdf",
	// 		},],			
	// 	nombre:"Mejoramiento Genético Ovino",
	// 	anio:"2023"
	// },
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "1° Entrega (Segundo Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/2T/Apicultura.pdf",
			},
			{
				 id: "2",
			  nombrelink: "2° Entrega (Tercer Trimestre)",
			  enlace:
				"https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/3T/BeneficiariosApicola.pdf",
			},],			
		nombre:"Apicultura",
		anio:"2023"
	},
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/Cunicultura2023.pdf",
	// 		},],			
	// 	nombre:"Cunicultura",
	// 	anio:"2023"
	// },
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Entrega 3er Trimestre",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/3T/BeneficiariosMagueyXamini.pdf",
			},],
		nombre:"Hijuelos de Maguey Xamini",
		anio:"2023"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Entrega 3er Trimestre",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2023/3T/BeneficiariosMagueyManzo.pdf",
			},],
		nombre:"Hijuelos de Maguey Manzo",
		anio:"2023"
	},
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/EAcuicola2023.pdf",
	// 		},],			
	// 	nombre:"Equipamiento Acuícola",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/EMaguey2023.pdf",
	// 		},],			
	// 	nombre:"Equipamiento de Maguey",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/ECafe2023.pdf",
	// 		},],			
	// 	nombre:"Equipamiento de Café",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/EBovino2023.pdf",
	// 		},],			
	// 	nombre:"Equipamiento Bovino",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/EOvino2023.pdf",
	// 		},],			
	// 	nombre:"Equipamiento Ovino",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/EPorcino2023.pdf",
	// 		},],			
	// 	nombre:"Equipamiento Porcino",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/ELeche2023.pdf",
	// 		},],			
	// 	nombre:"Equipamiento Producción de Leche",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/ECertifiadoI2023.pdf",
	// 		},],			
	// 	nombre:"Equipamiento Certificado de Inocuidad",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/EAgrícola2023.pdf",
	// 		},],			
	// 	nombre:"Equipamiento Agrícola",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/EFertilizante2023.pdf",
	// 		},],			
	// 	nombre:"Equipamiento Fertilizante",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/Huertos2023.pdf",
	// 		},],				
	// 	nombre:"Huertos Familiares",
	// 	anio:"2023"
	// },
	// {
	// 	urls: [
	// 		{
	// 		  id: "1",
	// 		  nombrelink: "Ver Padrón",
	// 		  enlace:
	// 			"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Beneficiarios/2023/AgreacionMujer2023.pdf",
	// 		},],			
	// 	nombre:"Agrgación de Valor para Mujer Rural",
	// 	anio:"2023"
	// },
	
	
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2022/PUBLICACION_PRODUCTORES_SAC_2022.pdf",
			},],			
		nombre:"Seguro Agrícola Catastrófico",
		anio:"2022"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2022/Avena_2022.pdf",
			},],			
		nombre:"Avena",
		anio:"2022"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2022/Aves_Postura_2022.pdf",
			},],			
		nombre:"Aves Postura",
		anio:"2022"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2022/Cebada_2022.pdf",
			},],			
		nombre:"Cebada",
		anio:"2022"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2022/Herramientas_2022.pdf",
			},],			
		nombre:"Herramientas",
		anio:"2022"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2022/Maiz_2022.pdf",
			},],			
		nombre:"Maiz",
		anio:"2022"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2022/Semen_Sexado_2022.pdf",
			},],			
		nombre:"Semen Sexado",
		anio:"2022"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2022/CriasTruchas2022.pdf",
			},],			
		nombre:"Entrega De Crias de Truchas",
		anio:"2022"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2022/CriasBagre2022.pdf",
			},],			
		nombre:"Entrega De Crias de Bagre",
		anio:"2022"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/PUBLICACION_RESUMEN_SAC_2021.pdf",
			},],			
		nombre:"Seguro Agrícola Catastrófico (SAC)",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/PROGRAMA_DE_INFRAESTRUCTURA_USO_COLECTIVO_ALMACENAMIENTO_APROVECHAMIENTO_AGUA_2021.pdf",
			},],			
		nombre:"Programa de Infraestructura Para El Uso Colectivo, Almacenamiento y Aprovechamiento de Agua",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/PROGRAMA_DE_SANIDAD_E_INOCUIDAD_AGROALIMENTARIA_2021.pdf",
			},],			
		nombre:"Programa de Sanidad e Inocuidad Agroalimentaria",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/ROLLOXROLLO_2021.pdf",
			},],			
		nombre:"Entrega de Alambre de Púas (Rollo x Rollo)",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/ENTREGA_VIENTRES_2021.pdf",
			},],			
		nombre:"Entrega de Vientres Ovinos",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/AVES_2021.pdf",
			},],			
		nombre:"Entrega de Paquete de Aves de Postura",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/FERTILIZANTE_2021.pdf",
			},],			
		nombre:"Entrega de Fertilizante",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/AVENA_2021.pdf",
			},],			
		nombre:"Entrega de Semilla de Avena",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/SEMEN_SEXADO_2021.pdf",
			},],			
		nombre:"Entrega de Dosis de Semen Sexado",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/MAIZ_2021.pdf",
			},],			
		nombre:"Entrega de Semilla Certificada de Maíz",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/CEBADA_2021.pdf",
			},],			
		nombre:"Entrega de Semilla de Cebada",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/CRIAS_TRUCHA_2021.pdf",
			},],			
		nombre:"Entrega de Crías de Trucha Arcoíris",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2021/PROGRAMA CONCURRENTE CONAGUA-SEDAGROH 2021.pdf",	
			},],
		nombre:"Programa Concurrente CONAGUA-SEDAGROH",
		anio:"2021"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/PROGRAMA CONCURRENTE CONAGUA-SEDAGRO 2020.pdf",	
			},],
		nombre:"Programa Concurrente CONAGUA-SEDAGROH",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/Cemento_2020.pdf",	
			},],			
		nombre:"Entrega de Cemento",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/PROGRAMA_SANIDAD_INOCUIDAD_AGROALIMENTARIA_2020.pdf",	
			},],			
		nombre:"Programa de Sanidad e Inocuidad Agroalimentaria",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/Frijol_2020.pdf",	
			},],			
		nombre:"Entrega de Semilla de Frijol",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/SEGURO_AGRIC_2020.pdf",	
			},],			
		nombre:"Seguro Catastrófico Agrícola",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/ALFALFA_2020.pdf",	
			},],			
		nombre:"Entrega de Semilla de Alfalfa",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/REFRACTROMETROS_2020.pdf",	
			},],			
		nombre:"Entrega de Refractrometros",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/SEMEN_SEXADO_2020.pdf",	
			},],			
		nombre:"Entrega de Semen Sexado",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/MAIZ_2020.pdf",
			},],			
		nombre:"Entrega de Semilla Certificada de Maíz",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/AVENA_2020.pdf",
			},],			
		nombre:"Entrega de Semilla Avena",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/HERRAMIENTAS_2020.pdf",
			},],			
		nombre:"Entrega de Paquete de Herramientas",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/FERTILIZANTE_2020.pdf",
			},],			
		nombre:"Entrega de Fertilizante",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/MOCHILAS_2020.pdf",
			},],			
		nombre:"Entrega de Mochilas Aspersoras",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/CEBADA_2020.pdf",
			},],			
		nombre:"Entrega de Semilla Cebada",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/LECHONES_2020.pdf",
			},],			
		nombre:"Entrega de Lechones F2 para Engorda",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/PASTO_2020.pdf",
			},],			
		nombre:"Entrega de Semilla para Pasto",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/Ovinos_2020.pdf",
			},],			
		nombre:"Entrega de Vientres Ovinos F1",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/AVES_2020.pdf",
			},],			
		nombre:"Entrega de paquetes de Aves de Postura",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2020/Revestimiento_canales_20.pdf",
			},],			
		nombre:"Entrega de Material para el Revestimiento de Canales",
		anio:"2020"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2019/SAC_2019_SADER.pdf",
			},],			
		nombre:"Seguro Agrícola Catastrófico (SAC)",
		anio:"2019"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2019/Solicitudes Programa de Desarrollo Rural 2019.pdf",
			},],			
		nombre:"Solicitudes Autorizadas del Programa de Desarrollo Rural",
		anio:"2019"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2019/Concurrencia_Folios_Autorizados_2019.pdf",
			},],			
		nombre:"Concurrencia con las Entidades Federativas - Folios",
		anio:"2019"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2019/BENEFICIARIOS ACEMILAS PRESUPUESTO.pdf",
			},],			
		nombre:"Entrega de Acémilas (Ganado Mular) - Ley de Presupuesto y Contabilidad Gubernametal",
		anio:"2019"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2019/BENEFICIARIOS AVES DE POSTURA PRESUPUESTO.pdf",
			},],			
		nombre:"Entrega de Aves para la Producción de Huevo en Áreas Rurales - Ley de Presupuesto y Contabilidad Gubernametal",
		anio:"2019"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2019/BENEFICIARIOS VIENTRES BOVINOS PRESUPUESTO.pdf",
			},],		
		nombre:"Entrega de Vientres Bovinos para el Fortalecimiento del Inventario y el Incremento en la Producción de Leche - Ley de Presupuesto y Contabilidad Gubernametal",
		anio:"2019"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2019/BENEFICIARIOS VIENTRES OVINOS PRESUPUESTO.pdf",
			},],			
		nombre:"Entrega de Vientres Ovinos F1, para Incrementar la Producción de Carne Ovina  - Ley de Presupuesto y Contabilidad Gubernametal",
		anio:"2019"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2019/BENEFICIARIOS ACEMILAS.pdf",
			},],			
		nombre:"Entrega de Acémilas (Ganado Mular) - Ley General de Transparencia y Acceso a la Información Pública",
		anio:"2019"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2019/BENEFICIARIOS AVES DE POSTURA.pdf",
			},],			
		nombre:"Entrega de Aves para la Producción de Huevo en Áreas Rurales - Ley General de Transparencia y Acceso a la Información Pública",
		anio:"2019"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2019/BENEFICIARIOS VIENTRES BOVINOS.pdf",
			},],			
		nombre:"Entrega de Vientres Bovinos para el Fortalecimiento del Inventario y el Incremento en la Producción de Leche - Ley General de Transparencia y Acceso a la Información Pública",
		anio:"2019"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2019/BENEFICIARIOS VIENTRES OVINOS.pdf",
			},],			
		nombre:"Entrega de Vientres Ovinos F1, para Incrementar la Producción de Carne Ovina  - Ley General de Transparencia y Acceso a la Información Pública",
		anio:"2019"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2019/Concurrencia_2019.pdf",
			},],			
		nombre:"Programa de Concurrencia con las Entidades Federativas",
		anio:"2019"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2018/Anexouno-punto5.pdf",
			},],			
		nombre:"Cierre Finiquito del Seguro Pecuario Catastrófico",
		anio:"2018"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2018/ComplementoPadronPunto5.pdf",
			},],			
		nombre:"Cierre Finiquito del Seguro Pecuario Catastrófico (Complemento)",
		anio:"2018"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2018/PESA_2018.pdf",
			},],			
		nombre:"Beneficiarios PESA.",
		anio:"2018"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2018/Relacion de Grupos Extensionismo 2018.pdf",
			},],			
		nombre:"Programa de Extensionismo, Desarrollo de Capacidades y Asociatividad Productiva.",
		anio:"2018"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2018/concurrenciapecuario2018.pdf",
			},],				
		nombre:"Relación de proyectos pecuarios del programa de concurrencia.",
		anio:"2018"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2018/Concurrencia_Agricola_2018.pdf",
			},],				
		nombre:"Relación de proyectos agrícolas del programa de concurrencia.",
		anio:"2018"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2018/Concurrencia_Pesca_2018.pdf",
			},],			
		nombre:"Relación de proyectos acuícolas y pesqueros del programa de concurrencia.",
		anio:"2018"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2018/Sujetos de Apoyo HTN 1a ETAPA.pdf",
			},],			
		nombre:"Relación de solicitudes apoyadas Programa Hidalgo Te Nutre 1a Etapa.",
		anio:"2018"
	},
	{
		urls: [
			{
			  id: "1",
			  nombrelink: "Ver Padrón",
			  enlace:
				"http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Beneficiarios/2018/Seguro_Agricola_2018.pdf",
			},],			
		nombre:"Seguro agrícola catastrófico",
		anio:"2018"
	},
	


]
